import React from 'react';
import { useIntl } from 'react-intl';

import TextFieldController from '../TextFieldController';

function EmailFieldController({ name = 'email', ...props }: any) {
  const intl = useIntl();

  return (
    <TextFieldController
      name={name}
      type="email"
      placeholder={intl.formatMessage({ id: 'AUTH.EMAIL_PLACEHOLDER' })}
      label={intl.formatMessage({ id: 'SIGN_UP.EMAIL' })}
      slotProps={{
        input: {
          autoComplete: 'email',
        },
      }}
      rules={{
        required: intl.formatMessage({ id: 'AUTH.ERRORS.REQUIRED_EMAIL' }),
      }}
      {...props}
    />
  );
}

export default EmailFieldController;
